import { Component, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { dsDtos } from '@vectronic/openApi-admin';
import { DisabledSubsystemsDialogComponent } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';

@Component({
  selector: 'table-datatable-disabled-subsystems',
  templateUrl: './datatable-disabled-subsystems.component.html',
  styleUrls: ['./datatable-disabled-subsystems.component.scss'],
  imports: [MatButtonModule],
})
export class DatatableDisabledSubsystemsComponent {
  subsystems = input<dsDtos.Subsystem[]>();
  idDevice = input<number>();
  deviceClassId = input<string>();
  disabledSubsystems = input<boolean[]>();
  deviceClasses = input<dsDtos.DeviceClass[]>();
  isCompactModeActivated = input<boolean>();

  private dialogService = inject(DialogService);

  onClickDisabledSubsystems() {
    const deviceClass = this.deviceClasses()?.find(({ id }) => id === this.deviceClassId());
    this.dialogService.openWide(DisabledSubsystemsDialogComponent, {
      data: {
        subsystems: this.subsystems(),
        idDevice: this.idDevice(),
        disabledSubsystems: this.disabledSubsystems(),
        deviceClassName: deviceClass?.name,
      },
    });
  }
}
